import { render, staticRenderFns } from "./QuotationOtherItemsTable.vue?vue&type=template&id=674c918a&scoped=true"
import script from "./QuotationOtherItemsTable.vue?vue&type=script&lang=js"
export * from "./QuotationOtherItemsTable.vue?vue&type=script&lang=js"
import style0 from "./QuotationOtherItemsTable.vue?vue&type=style&index=0&id=674c918a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674c918a",
  null
  
)

export default component.exports